import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Settings } from "lucide-react";
import { useTranslations } from "use-intl";
import { requireRole } from "@/lib/auth/require-role";
import { PageHeader } from "@/components/ui/page-header";
import { SettingsTabStrip } from "@/features/settings/components/settings-tab-strip";

// Settings shell — horizontal-tab layout.
// /settings redirects to /settings/general so users always land on a populated tab.
export const Route = createFileRoute("/_admin/settings")({
  beforeLoad: async ({ location }) => {
    await requireRole("admin");
    if (location.pathname === "/settings" || location.pathname === "/settings/") {
      throw redirect({ to: "/settings/general", replace: true });
    }
  },
  component: SettingsShell,
});

function SettingsShell() {
  const t = useTranslations("settings");

  return (
    <div className="space-y-6">
      <PageHeader
        icon={Settings}
        title={t("page_title")}
        description={t("page_description")}
      >
        <SettingsTabStrip />
      </PageHeader>
      <Outlet />
    </div>
  );
}
